export default {
  success: 'Success',
  warning: 'Warning',
  info: 'Info',
  error: 'Error'
}



// WEBPACK FOOTER //
// ./src/lang/en/public/message.js